import { PlusCircleSVG, TrashSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import { HalfContainer, SeparatorVertical } from 'components/styles';
import { Row, SectionContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { InputContainer, RightButtonContainer } from '../../style';
import { TourListFormType } from '../form-type';
import { onAddNewOtherPrice } from '../hooks/use-get-default-values';

export default function OtherPriceSection() {
  const { t } = useTranslation();
  const { control, clearErrors } = useFormContext<TourListFormType>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tourOtherPrices',
    keyName: '__customId',
  });

  const onAdd = () => {
    append(onAddNewOtherPrice());
    clearErrors();
  };

  const onRemove = (index: number) => {
    remove(index);
    clearErrors();
  };

  const { editable } = useFormState();

  return (
    <div>
      <Text variant="HeadingXSmall">{t('common:other_price')}</Text>
      <SeparatorVertical $margin={16} />
      {fields.length === 0 && !editable && (
        <Text variant="ParagraphSmall">{t('common:no_data')}</Text>
      )}

      {fields.map((field, idx) => (
        <Row $style={{ justifyContent: 'space-between' }} key={field.customId}>
          <SectionContainer>
            <HalfContainer>
              <InputContainer>
                <Input
                  type="text"
                  name={`tourOtherPrices[${idx}].description`}
                  label={t('common:description')}
                  placeholder={t('common:description')}
                  noMargin
                />
              </InputContainer>
            </HalfContainer>
            <Separator gap={24} direction="horizontal" />

            <HalfContainer>
              <Input
                type="number"
                name={`tourOtherPrices[${idx}].price`}
                label={t('common:price')}
                placeholder={t('common:price')}
                required
                noMargin
              />
            </HalfContainer>
            <RightButtonContainer>
              {editable && (
                <IconButton
                  buttonType="tertiary"
                  overrides={{
                    Root: {
                      style: {
                        height: '100%',
                        ':hover': {
                          backgroudnColor: stylesColors.redDefault,
                        },
                      },
                    },
                  }}
                  onClick={() => onRemove(idx)}
                >
                  <TrashSVG color={stylesColors.redDefault} />
                </IconButton>
              )}
            </RightButtonContainer>
          </SectionContainer>
        </Row>
      ))}
      {editable ? (
        <Button
          startEnhancer={(color, size) => (
            <PlusCircleSVG color={color} size={size} />
          )}
          buttonType="secondary"
          onClick={onAdd}
        >
          {t('common:add')}
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
}
